import React, {Component} from 'react';
import SideBar from './sidebar/SideBar';
import Footer from './components/Footer';
import Nav from './Header/Nav';
import vscode from '../assets/images/vscode.jpg';
import jssvg from '../assets/images/js.svg';
import fullstackjs from '../assets/images/fullstackjs.jpg';
import DevelopRequest from './components/DevelopRequest';
import Subscribe from './components/Subscribe';

class FullStackWeb extends Component{
    render(){
        return(
            <div id="App">
            <SideBar />
                <Nav />
            <header className="showcase" style={{height:'80vh', marginTop:'5vh', backgroundImage: `url(${fullstackjs})`}}>
			<div className="showcase-content">
                <div></div>
                <div>
				<h1>Be in <span className="alt-col" style={{color:'rgba(226, 155, 24, 0.945)'}}> Demand.</span></h1>
                <p>"It's not a bug &mdash; it's an undocumented feature."</p>
                <p>
                &mdash; Anonymous.
                </p>
                </div>
			</div>
		</header>
        <div className="about">
            <div style={{backgroundImage: `url(${vscode})`, backgroundClip:'border-box', backgroundPosition:'center', backgroundSize:'cover'}}></div>

            <div>
            <h3 className="path">Full-stack web development</h3>
            <img src={jssvg} alt="Full-stack JavaScript training in abuja" />
            <p> 
              Get the very best of full-stack web development training. Learn how to build dynamic and eye-catching websites.
            </p>
            <p> 
            Your full-stack web development journey begins here.
            </p>

            <h3>courses</h3>
            <p>
                HTML5, CSS3, Bootstrap 4, ES6, PHP, MysQL.
            </p>

            <h3>call anytime</h3>
            <p>07063509602, 07084894979</p>
            <p>info@codeflarelimited.com</p>

            <h3>visit us</h3>
            <p>Suite C3-19 Central Market Plaza, Beside Sledge Resort, Off Byazhin Roundabout, Kubwa, Abuja.</p>
            </div>
        </div>
        <DevelopRequest />
        <Subscribe />
        <Footer />
            </div>
        )
    }
}

export default FullStackWeb;